import { UserListMinimal } from 'libs/domain';

import { BottomSheetEventType } from '../bottom-sheet';
import {
  CategoryItem,
  OptionItem,
  SelectGroupCategory,
} from '../form/components/form-grouped-select/form-grouped-select.types';

export enum UserListCategory {
  MY_LISTS = 'myLists',
  MY_LISTS_CURRENT_TERM = 'myListsCurrentTerm',
  ALL = 'all',
  ALL_CURRENT_TERM = 'allCurrentTerm',
  TODAYS_FLEX_ACTIVITIES = 'todaysFlexActivities',
  TODAYS_FLEX_ACTIVITIES_MINE = 'todaysFlexActivitiesMine',
  HOMEROOM = 'homeroom',
  HOMEROOM_MINE = 'homeroomMine',
}

export type UserListBottomSheetData = {
  id?: string;
  initialOptions: OptionItem<number, UserListMinimal>[] | OptionItem<number, UserListMinimal>;
  disabled?: boolean;
  options: SelectGroupCategory<string, number, UserListMinimal>[];
  multiple?: boolean;
};

export type UserListBottomSheetResponse = {
  type: BottomSheetEventType;
  data: {
    selectedLists: OptionItem | OptionItem[] | null;
    lastSelectedCategory: CategoryItem;
  };
};

type Explicit = OptionItem | OptionItem[];
type Implicit = number | number[];
export type InitialValue = Implicit | Explicit;
